import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import Pasos from "./Pasos";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/reservas",
    label: "Reservas",
  },
  {
    path: "/spa",
    label: "Spa",
    isActive: true,
  },
];

function ReservarSpa() {
  return (
    <Page
      title="Reserva de Spa"
      description="Agendamiento de días de spa para mascota."
      breadCrumbs={breadCrumbs}
    >
      <Pasos />
    </Page>
  );
}

export default ReservarSpa;
